import { Component, OnInit } from '@angular/core';
import { ForuscareService } from '../services/foruscare/foruscare.service';
import { AccountService } from '../services/account/account.service';
import { ServiceProviderService } from '../services/service-provider/service-provider.service';
import { LabelConfig } from '../models/labelConfig';

@Component({
  selector: 'app-label-config',
  templateUrl: './label-config.component.html',
  styleUrls: ['./label-config.component.css']
})
export class LabelConfigComponent implements OnInit {
  accounts: any[] = []; providers: any[] =[]; accountId = null; providerId = null;
  labelConfig:LabelConfig;
  constructor(private foruscareService: ForuscareService, private accountService: AccountService,private serviceProviderService:ServiceProviderService) { }

  ngOnInit() {
    this.labelConfig = new LabelConfig();
    this.getAvailableAccounts();
    this.getExistingServiceProviders();
  }
  
  getAvailableAccounts() {
    this.accounts = [];
    this.accountService.getExistingAccounts()
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            if (response.data.length > 0) {
              response.data.unshift({
                accountName: 'Select Account',
                accountId: 0
              });
            }
            this.accounts = response.data;
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }
  getExistingServiceProviders() {
    this.providers = [];
    this.serviceProviderService.getExistingProviders()
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
              this.providers = response.data;
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }
  getLabelConfigByAccountId(){

  }
  getLabelConfigByProviderId(){
    
  }
  saveLabelConfig(){
    console.log(this.labelConfig);
  }
}
